import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  GlobalStyles,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { SideNav } from './layout/side-navBuyer'; // Import for Buyer SideNav
import { MobileNav } from './layout/mobile-navBuyer'; // Import for Buyer MobileNav
import NavIcons from './layout/nav-icons'; // Import for navigation icons
import './CSS/BuyerTemplate.css'; // Import associated CSS for Buyer template

const BuyerTemplate = ({ title, children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Check for mobile screen size
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false); // State to toggle mobile menu visibility

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen((prevState) => !prevState); // Toggle mobile menu visibility
  };

  return (
    <>
      {/* Global styles for layout */}
      <GlobalStyles
        styles={{
          body: {
            '--MainNav-height': '56px',
            '--SideNav-width': '250px',
            '--MobileNav-width': '100%', // Mobile nav takes full width
          },
        }}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          bgcolor: 'background.default',
        }}
      >
        {/* Sidebar for non-mobile screens */}
        {!isMobile && <SideNav />}

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            transition: 'margin-left 0.3s ease', // Smooth transition for mobile menu
            pl: isMobile ? 0 : 'var(--SideNav-width)', // Adjust padding for larger screens
          }}
        >
          {/* Mobile navigation menu */}
          {isMobile && (
            <>
              <MobileNav open={isMobileMenuOpen} onClose={handleMobileMenuToggle} />
              <Box
                sx={{
                  position: 'absolute',
                  top: 16,
                  left: 16,
                  zIndex: 1200, // Ensures the icon is above other content
                }}
              >
                <NavIcons onClick={handleMobileMenuToggle} />
              </Box>
            </>
          )}

          {/* Page header */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              p: 2,
              zIndex: 1000,
            }}
          >
            <Typography variant="h6">{title}</Typography>
          </Box>

          {/* Page content */}
          <Container sx={{ flex: 1, px: 2 }}>{children}</Container>
        </Box>
      </Box>
    </>
  );
};

export default BuyerTemplate;
